import { useTranslation } from '@whoop/i18n/lang/client';
import { Button } from 'ui/components/ButtonV2/Button';
import { getFormatters } from 'ui/hooks/formatter';
import { useShallow } from 'zustand/react/shallow';
import { useSiteStore } from '@/store/SiteStoreProvider';
import { TRIAL_MEMBERSHIP_KEY } from 'ui/utils/constants/membershipConstants';
import { hasMembershipKey } from 'ui/utils/membershipHelpers';

interface LandingPageBottomCTAProps {
  onClick: () => void;
  disabled: boolean;
  skipGiftSelection: boolean;
}

function LandingPageBottomCTA({
  onClick,
  disabled,
  skipGiftSelection,
}: LandingPageBottomCTAProps): JSX.Element {
  const { language, region, currency, ecommCatalog } = useSiteStore(
    useShallow((state) => ({
      currency: state.currency,
      region: state.region,
      language: state.language,
      ecommCatalog: state.ecommCatalog,
    })),
  );
  const { formatDisplayPrice } = getFormatters({ currency, language, region });
  const { t } = useTranslation('joinLandingPage');
  const showTrialsDisclaimer = hasMembershipKey(
    TRIAL_MEMBERSHIP_KEY,
    ecommCatalog.memberships,
  );

  return (
    <section className='order-last w-full bg-black px-4 py-20 sm:px-8'>
      <div className='mx-auto flex max-w-screen-md flex-col items-center gap-10 text-center'>
        <h3 className='text-3xl text-white'>
          {skipGiftSelection ? t('footerHeadingGift') : null}
          {showTrialsDisclaimer && !skipGiftSelection
            ? t('footerHeading', {
                price: formatDisplayPrice(0),
              })
            : null}
          {!showTrialsDisclaimer && !skipGiftSelection
            ? t('noTrialsFooterHeader')
            : null}
        </h3>
        <div className='flex flex-col items-center gap-24'>
          <div className='w-full max-w-2xl px-2 sm:px-10'>
            <Button
              disabled={disabled}
              onClick={onClick}
              size='medium'
              variant='secondaryBright'
            >
              {skipGiftSelection ? t('continue') : t('footerCTA')}
            </Button>
          </div>
          <p className='max-w-2xl px-4 text-sm text-white  sm:px-16'>
            {t('footerParagraph')}
          </p>
        </div>
      </div>
    </section>
  );
}

export default LandingPageBottomCTA;
